import { useMemo, useContext } from 'react';
import { DataContext } from '../contexts/DataContext';
import config from '../config/kystverket';
import { getLength } from 'ol/sphere';

const useItem = ({ type, id }) => {
  const { items, loading } = useContext(DataContext);

  const item = useMemo(() => {
    if (!items) return;

    const idKey = config.themes[type].id;

    const currentItem = items.find(i => i.type === type && i[idKey] === id);
    if (currentItem) {
      const geom = currentItem.olFeature.getGeometry();
      if (geom.getType() === 'LineString') {
        currentItem.calcLength = getLength(geom, { projection: 'EPSG:3857' });
      }
    }
    return currentItem;
  }, [items, type, id]);

  return { loading, item };
};

export default useItem;
